import { getPersonalSurveys } from '../services/questionnaire';
import SurveyDTO from '../interfaces/dto/surveyDTO';
import Survey from '../interfaces/survey';
import QuestionDTO from '../interfaces/dto/questionDTO';
import Question from '../interfaces/question';

const processNestedQuestions = ({
  nestedQuestions,
}: {
  nestedQuestions: QuestionDTO[];
}): Question[] => {
  if (!nestedQuestions) return [];
  return nestedQuestions.map((nestedQuestion: QuestionDTO) => ({
    ...nestedQuestion,
    questions: [],
    isSubQuestion: true,
  }));
};

const processFirstOrderQuestions = ({ questions }: { questions: QuestionDTO[] }): Question[] => {
  if (!questions) return [];
  return questions.map((question: QuestionDTO) => ({
    ...question,
    questions: processNestedQuestions({ nestedQuestions: question.questions }),
    isSubQuestion: false,
  }));
};

const dtoToSurvey = ({ surveys }: { surveys: SurveyDTO[] }): Survey => {
  const [firstSurvey] = surveys;
  return {
    ...firstSurvey,
    questions: processFirstOrderQuestions({ questions: firstSurvey.questions }),
  };
};

const query = async (): Promise<Survey> => {
  const surveys = await getPersonalSurveys();
  return dtoToSurvey({ surveys });
};

const personalSurveyQuery = {
  key: 'personalSurvey',
  query,
};

export { dtoToSurvey, personalSurveyQuery };
